import { render, staticRenderFns } from "./DialogAddUser.vue?vue&type=template&id=ec3711a4"
import script from "./DialogAddUser.vue?vue&type=script&lang=ts"
export * from "./DialogAddUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports